import { Flex, Stack, Text } from '@chakra-ui/react'

import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'

import { ContentLabel } from './Insurer'

const baseUrl = AppSettings.baseUrl + '/docs/cpp/'

const CPPContent = () => {
  return (
    <Stack m={4} gap={10}>
      <Documents />
    </Stack>
  )
}

export default CPPContent

const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'cpp_vpp.pdf',
            name: 'Pojistné podmínky Autopojištění Combi Plus IV 1/24',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_vpp_dynamic.pdf',
            name: 'Soubor pojistných podmínek Autopojištění Combi Plus IV 1/24',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_prehled_asistenci.pdf',
            name: 'Přehled asistencí - Rozsah asistenčních služeb',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_dokument_pojisteni_vozidel_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_produktovy_list_acp_iv.pdf',
            name: 'Produktový list ACP IV',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_ipzop.pdf',
            name: 'INFORMACE PRO ZÁJEMCE O POJIŠTĚNÍ',
            documentType: 'pdf'
          }
        ]} />

        <ContentLabel label='Vstupní prohlídky vozidel' />
        <DocumentsList items={[
          {
            url: baseUrl + 'cpp_metodika_fotografovani.pdf',
            name: 'POMŮCKA PRO SJEDNATELE - FOTOGRAFOVÁNÍ VOZIDEL',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_faq_samofoceni.pdf',
            name: 'Samofocení FAQ',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_navod_samofoceni_obrazkovy.pdf',
            name: 'Samofocení návod (obrázkový)',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'cpp_navod_samofoceni_textovy.pdf',
            name: 'Samofocení návod (textový)',
            documentType: 'pdf'
          },
        ]} />

      </Stack>
    </Stack >
  )
}